import {
  AvailablePreTestConfigurationOptions,
  AvailableKINSpecificConfigurationOptions,
  KineticPerimetryPattern,
  TestConfiguration,
  KineticTestCustomConfiguration,
} from "types/testTypes";
import { availableKineticPerimetryTestConfigurationOptions } from "@constants/testConstants/testSpecificConstants";
import { CONFIGURATION_VALUE_LABEL_KEY_MAP } from "@constants/uiConstants";
import { cloneDeep } from "lodash";

export function getKineticPatternLabelKey(pattern: KineticPerimetryPattern): string {
  const labelKey =
    CONFIGURATION_VALUE_LABEL_KEY_MAP[pattern as keyof typeof CONFIGURATION_VALUE_LABEL_KEY_MAP]
      ?.labelKey;
  return labelKey ?? pattern;
}

export function getKineticPatternDefaults(
  pattern?: KineticPerimetryPattern,
  testTypeCircleAngle?: number,
  numberOfStimuliStarts?: number,
) {
  switch (pattern) {
    case KineticPerimetryPattern.FF_60_12:
      return { testTypeCircleAngle: 60, numberOfStimuliStarts: 12 };
    case KineticPerimetryPattern.FF_50_12:
      return { testTypeCircleAngle: 50, numberOfStimuliStarts: 12 };
    case KineticPerimetryPattern.FF_30_8:
      return { testTypeCircleAngle: 30, numberOfStimuliStarts: 8 };
    case KineticPerimetryPattern.FF_CUSTOM:
      return {
        testTypeCircleAngle: testTypeCircleAngle ?? 30,
        numberOfStimuliStarts: numberOfStimuliStarts ?? 8,
      };
    default:
      return { testTypeCircleAngle: 30, numberOfStimuliStarts: 8 };
  }
}

export function getFixationShiftAngle(
  pattern?: KineticPerimetryPattern,
  testTypeCircleAngle?: number,
  numberOfStimuliStarts?: number,
) {
  const circleAngle = getKineticPatternDefaults(
    pattern,
    testTypeCircleAngle,
    numberOfStimuliStarts,
  ).testTypeCircleAngle;
  return circleAngle < 50 ? 0 : Math.min(circleAngle - 50, 40);
}

export function GetUpdatedAvailableKineticConfigsAfterConfigUpdate(
  requestedUpdate: Partial<TestConfiguration>,
  baseOptions?: AvailablePreTestConfigurationOptions | null,
): AvailablePreTestConfigurationOptions {
  let availableKineticConfig: AvailablePreTestConfigurationOptions = cloneDeep(
    baseOptions ?? availableKineticPerimetryTestConfigurationOptions,
  );

  const testPattern: KineticPerimetryPattern | undefined = (
    requestedUpdate.extraData as KineticTestCustomConfiguration
  )?.testPattern;

  // Only show number input options when FF_CUSTOM pattern is selected
  if (testPattern !== KineticPerimetryPattern.FF_CUSTOM) {
    const { testTypeCircleAngleOptions, numberOfStimuliStartsOptions, ...remainingOptions } =
      availableKineticConfig.testSpecificConfigurationOptions as AvailableKINSpecificConfigurationOptions;
    availableKineticConfig = {
      ...availableKineticConfig,
      testSpecificConfigurationOptions: remainingOptions,
    };
  }

  return availableKineticConfig;
}
